import { NgModule } from "@angular/core";
import { NgxCurrencyModule } from "./ngx-currency/currency-mask.module";
import { CountdownModule } from "ngx-countdown";

@NgModule({
  imports: [NgxCurrencyModule, CountdownModule],
  exports: [NgxCurrencyModule, CountdownModule],
})
export class NgxModule {}
